import Stack from '@zenbusiness/zui/Stack';
import { styled } from '@zenbusiness/zui/styles';

export const IndicatorContainer = styled(Stack)(() => ({
  alignItems: 'center',
  justifyContent: 'center',
  marginBlock: '0.75rem 0.25rem',
}));
